import React from 'react';
import { useAuth } from '../context/AuthContext';

export type ProtectedRouteProps = {
  alias: string;
  children: React.ReactNode;
};

export const ProtectedRoute = ({ alias, children }: ProtectedRouteProps) => {
  const { userLogged, userPermissions } = useAuth();

  if (userLogged && userPermissions.includes(alias)) return children;

  const apiBase = process.env.REACT_APP_URL_API?.replace(/\/+$/, '') || window.location.origin;
  window.location.assign(`${apiBase}/system/login`);
  return null;
};
